module.exports = __webpack_public_path__ + "img/np-mobile-1.fee67287.webp";